import "./App.css";
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import MapWithAddMarker from "./component/maps/map";
import Header from "./component/Header/Header";
import Footer from "./component/Footer/Footer";
import Layout from "./Layout.jsx";
import Login from "./component/Login/Login";
import { getCookie } from "./utils/getCookie.js";
import ForgetPassword from "./component/Login/ForgetPassword";
import Otp from "./component/Login/Otp";
import ChangePass from "./component/Login/ChangePass";
import { getUser } from "./../src/component/api/getUser";
import AdminPanel from "./component/Admin/AdminPanel";

function App() {
  const [markers, setMarkers] = useState([]);
  // Read the cookie during the first render, not in the effect. Starting at
  // false made the first render of any guarded route redirect to /login before
  // the check had run; the effect then flipped it true and /login bounced to /,
  // so a direct visit to /admin never landed there.
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!getCookie("access_token"));
  const [province, setProvince] = useState(null);
  const [isAdmin, setIsAdmin] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  // isAdmin resolves asynchronously, so "not an admin" and "we don't know yet"
  // are different states. Without this flag the /admin guard would redirect a
  // genuine admin on every page refresh, before getUser() comes back.
  const [userLoaded, setUserLoaded] = useState(false);

  useEffect(() => {
    const accessToken = getCookie("access_token");

    if (!accessToken) {
      setUserLoaded(true);
      return;
    }

    (async () => {
      try {
        const userData = await getUser();
        setProvince(userData.province);
        setIsAdmin(userData.is_admin);
        setIsSuperAdmin(userData.is_super_admin === true);
      } catch (error) {
        console.error("❌ خطا در گرفتن اطلاعات کاربر:", error);
      } finally {
        setUserLoaded(true);
      }
    })();
  }, []);

  const handleAddMarker = (newMarker) => {
    setMarkers([...markers, newMarker]);
  };

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  return (
    <Router>
      <Routes>
        <Route
          path='/login'
          element={
            isAuthenticated ? (
              <Navigate to='/' />
            ) : (
              <Login onLoginSuccess={handleLoginSuccess} />
            )
          }
        />
        <Route path='/forget_password' element={<ForgetPassword />} />
        <Route path='/change_password' element={<ChangePass />} />
        <Route path='/otp' element={<Otp />} />
        <Route
          path='/admin'
          element={
            !isAuthenticated ? (
              <Navigate to='/login' />
            ) : !userLoaded ? (
              <div className='p-6 text-center'>در حال بارگذاری...</div>
            ) : isSuperAdmin ? (
              <Layout isSuperAdmin={isSuperAdmin}>
                <AdminPanel />
              </Layout>
            ) : (
              <Navigate to='/' />
            )
          }
        />
        <Route
          path='/'
          element={
            isAuthenticated ? (
              <Layout isSuperAdmin={isSuperAdmin}>
                <MapWithAddMarker
                  markers={markers}
                  onAddMarker={handleAddMarker}
                  province={province}
                  isAdmin={isAdmin}
                />
              </Layout>
            ) : (
              <Navigate to='/login' />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
